export class AnalyzerChartData {
    constructor(underlierPrice, zeroLineSeries, timeLineSeries, intrinsicSeries, volatilitySeries) {
        this.underlierPrice = underlierPrice;
        this.zeroLineSeries = zeroLineSeries;
        this.timeLineSeries = timeLineSeries;
        this.intrinsicSeries = intrinsicSeries;
        this.volatilitySeries = volatilitySeries;
    }
}
